<template>
  <div>
    <template v-if="article">
      <transition name="slide-l" mode="out-in" appear>
        <div class="panel wraper panel-gray">
          <div class="panel-header">
              <div class="panel-title">
                <article-path :id="fullId" />
              </div>
          </div>
            <div class="panel-body">
              <p class="in-top" v-if="currentType ==='a'" >
                <small class="view-label">
                  <q-icon name="fas fa-user-edit"/> {{authorName}} {{versionTime | formatTime}}
                </small>
              </p>
              <v-runtime-template :template="template"></v-runtime-template>
              <p v-if="article.tags" class="group">
                <q-chip small v-for="(tag, ind) in article.tags" color="primary" :key="ind">
                  {{tag}}
                </q-chip>
              </p>
              <tree-wiki :base="fullId"/>
            </div>
        </div>
      </transition>
      <pop-btn v-if="notDemo && article._id" class="mobile-hide" :btns="btns"/>
      <pop-hold v-if="notDemo && article._id" class="mobile-only" :btns="btns"/>
    </template>
    <template v-else>
      <div class="row justify-center">
        <q-spinner-dots :size=100 color="primary"></q-spinner-dots>
      </div>
    </template>
  </div>
</template>

<style>
</style>
<script type="text/babel">
import { mapGetters } from 'vuex';
import TreeWiki from 'components/tree-wiki.vue';
import PopBtn from 'components/pop-btn.vue';
import PopHold from 'components/pop-hold.vue';
import ArticlePath from 'components/article-path.vue';
import VRuntimeTemplate from 'v-runtime-template';

export default {
  name: 'wikiView',
  components: {
    TreeWiki,
    PopBtn,
    PopHold,
    ArticlePath,
    VRuntimeTemplate,
  },
  data() {
    if (this && !this.$options) { // because v-runtime-template and vuelidate conflict
      this.$options = {};
    }
    return {};
  },
  created() {
    // this.$store.dispatch('wiki/loadWikis');
  },
  computed: {
    ...mapGetters({
      versionTime: 'wiki/versionTime',
      currentType: 'wiki/currentType',
    }),
    template() {
      if (!this.article.content) {
        return `<div id="${this.article._id}></div>`;
      }
      return `<div id="${this.article._id}" class="article">${this.article.content}</div>`;
    },
    fullId() {
      return this.$route.params.fullId;
    },
    article() {
      return this.$store.state.wiki.currentItem;
    },
    authorName() {
      return this.$store.state.wiki.authorName;
    },
    notDemo() {
      return !this.$store.getters['wiki/isWikiDemo'];
    },
    btns() {
      return [
        {
          color: 'warning',
          click: this.goEdit,
          icon: 'create',
          tooltip: 'Изменить',
        },
        {
          color: 'positive',
          click: this.doAdd,
          icon: 'fa-file-alt',
          tooltip: 'Добавить статью',
          prefix: '+',
          hide: this.currentType !== 'a',
        },
        {
          color: 'negative',
          click: this.doDelete,
          icon: 'delete_forever',
          tooltip: 'Удалить',
          hide: this.currentType !== 'd' && this.currentType !== 'v',
        },
      ];
    },
  },
  watch: {
    fullId: {
      handler(value, oldValue) {
        console.log('fullId changed', oldValue, '>>', value);
        if (this.$utils.getId(value) === 'v') {
          this.$router.push(`/wiki/a:${this.$utils.getId(value, 1)}`);
        } else {
          this.$store.dispatch('wiki/loadWiki', { fullId: value });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$watch('article', (a) => {
      document.title = a ? a.title : 'Loading...';
      if (a) {
        this.$nextTick(this.formatArticle);
      }
    }, {
      immediate: true,
    });
  },
  beforeDestroy() {
  },
  methods: {
    formatArticle() {
      const updateCols = (table, cellMinWidth) => {
        let totalWidth = 0;
        let fixedWidth = true;
        const colgroup = table.insertBefore(document.createElement('colgroup'), table.firstChild);
        const tbody = table.getElementsByTagName('tbody')[0];
        console.log('*******************', tbody);
        const cells = tbody.childNodes[0].childNodes;
        console.log('cells', cells);
        const colWidths = [];
        Array.from(cells).forEach((cell) => {
          if (cell.attributes['data-colwidth']) {
            Array.prototype.push.apply(colWidths, cell.attributes['data-colwidth'].value.split(','));
          } else {
            colWidths.push('0');
          }
        });
        console.log('colWidths', colWidths);
        colWidths.forEach((colwidth) => {
          const hasWidth = parseInt(colwidth, 10);
          const cssWidth = hasWidth ? `${hasWidth}px` : '';
          totalWidth += hasWidth || cellMinWidth;
          if (!hasWidth) fixedWidth = false;
          colgroup.appendChild(document.createElement('col')).style.width = cssWidth;
        });

        if (fixedWidth) {
          table.style.width = `${totalWidth}px`;
        } else {
          table.style.width = '100%';
          table.style.minWidth = `${totalWidth}px`;
        }
      };

      const content = document.getElementById(this.article._id);
      const tables = content.getElementsByTagName('table');
      Array.from(tables).forEach(table => updateCols(table, 25));
      const ps = content.getElementsByTagName('p');
      Array.from(ps).forEach((p) => {
        if (!p.hasChildNodes()) {
          p.appendChild(document.createElement('br'));
        }
      });
    },
    goEdit() {
      this.$router.push(`/wikiedit/${this.fullId}`);
    },
    doAdd() {
      this.$router.push(`/wikinew/${this.fullId}`);
    },
    doDelete() {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: 'Этот черновик будет безвозвратно удален!',
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => this.$store.dispatch('wiki/deleteDraft', this.fullId))
        .then(() => {
          this.$store.commit('wiki/delFromW_P', this.fullId);
          if (this.article.parent_id === 'root') {
            this.$router.push('/wikis');
          } else {
            this.$router.push(`/wiki/${this.article.parent_id}`);
          }
        })
        .catch((err) => {
          this.$store.commit('pushError', {
            error: err.error || 'Ошибка!',
            message: err.message || 'Возможно удаление не произведено',
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wiki-view.vue